"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_BUILD_ITINERARY = exports.NEW_ORDER_LEG = exports.CUSTOM_LINE_INITIAL_STATE = exports.TRANSFER_LINE_INITIAL_STATE = exports.GOLF_LINE_INITIAL_STATE = exports.EXCURSTION_LINE_INITIAL_STATE = exports.HOTEL_ORDER_LINE_STATE = exports.BASE_EMAIL_TEMPLATE = exports.ADMIN_USER_ID = exports.CANCELLED_ORDER_STATUSES = exports.BREAKPOINTS = void 0;
const dayjs = require("dayjs");
const models_1 = require("../models");
const enums_1 = require("./enums");
exports.BREAKPOINTS = {
    mobile: 0,
    tablet: 640,
    desktop: 1024,
    ultrawide: 1280,
};
exports.CANCELLED_ORDER_STATUSES = [
    enums_1.OrderLineStatus.CANCELLED,
    enums_1.OrderLineStatus.CANCELLED_REJECTED_BY_CLIENT,
    enums_1.OrderLineStatus.CANCELLED_UNAVAILABLE,
];
exports.ADMIN_USER_ID = "8d86794f-9f63-4571-a12a-d7d4fd643b20";
exports.BASE_EMAIL_TEMPLATE = `
<!DOCTYPE html>
<html>
  <head>
    <meta name="viewport" content="width=device-width" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title>{{supplier.name}}</title>
    <link
      href="https://fonts.googleapis.com/css?family=Poppins:300,400,700,900&display=swap"
      rel="stylesheet"
    />
    <style>
    /* -------------------------------------
    GLOBAL RESETS
------------------------------------- */

/* FONTS */ 
u + #body a {
  color: #ea0508 !important;
}

u + #body .btn-primary a  {
  color: #fff !important;
}     

/*All the styling goes here*/

img {
  border: none;
  -ms-interpolation-mode: bicubic;
  max-width: 100%;
}
body {
  background-color: #ebebeb;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 18px;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
table {
  font-family: 'Poppins', sans-serif;
  border-collapse: separate;
  mso-table-lspace: 0pt;
  mso-table-rspace: 0pt;
  width: 100%;
}
table td {
  font-family: 'Poppins', sans-serif;
  vertical-align: top;
  font-size: 15px;
}

strong {
  font-size:15px;
  color:#000;
}
/* -------------------------------------
    BODY & CONTAINER
------------------------------------- */
.body {
  background-color: #ebebeb;
  width: 100%;
}
/* Set a max-width, and make it display as block so it will automatically stretch to that width, but will also shrink down on a phone or something */
.container {
  display: block;
  margin: 0 auto !important;
  /* makes it centered */
  max-width: 680px;
  padding: 10px;
  width: 680px;
}
/* This should also be a block element, so that it will fill 100% of the .container */
.content {
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
  max-width: 680px;
  padding: 10px;
}
.warning {
    background-color: #dbe0e5;
    font-size: 15px;
    padding: 16px 24px;
    text-align: center;
    font-weight: bold;
}
.warning a{
    font-size: 15px;
    color: #038ECF;
    text-decoration:underline;
}
/* -------------------------------------
    HEADER, FOOTER, MAIN
------------------------------------- */
.main {
  background: #ffffff;
  border-radius: 0px;
  width: 100%;
}
.wrapper {
  box-sizing: border-box;
  padding: 40px;
}
.content-block {
  padding-bottom: 10px;
  padding-top: 10px;
}
.footer {
  clear: both;
  margin-top: 10px;
  text-align: center;
  width: 100%;
}
.footer td,
.footer p,
.footer span,
.footer a {
  color: #999999 !important;
  font-size: 12px;
  text-align: center;
}
/* -------------------------------------
    TYPOGRAPHY
------------------------------------- */
h1,
h2,
h3,
h4 {
  color: #000000;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
  margin-bottom: 25px;
}
h1 {
  font-size: 21px;
  line-height: 133%;
  font-weight: 600;
  color: #222729;
  text-align: left;
  text-transform: capitalize;
}
h2 {
  font-size: 19px;
  line-height: 133%;
  font-weight: 600;
  color: #222729;
  text-align: left;
  margin: 30px 0px 10px 0px;
}
h3 {
  font-size: 17px;
  line-height: 133%;
  font-weight: 600;
  color: #A7A9A9;
  text-align: left;
  margin: 10px 0px 10px 0px;
}
h4 {
  font-size: 17px;
  line-height: 150%;
  font-weight: 600;
  color: #222729;
  text-align: left;
  margin: 30px 0px 10px 0px;
}
p,
ul,
ol {
  font-family: 'Poppins', sans-serif;
  color: #000;
  font-size: 15px;
  line-height: 150%;
  font-weight: normal;
  margin: 0;
  margin-bottom: 12px;
}
p li,
ul li,
ol li {
  list-style-position: inside;
  margin-left: 5px;
}
a {
  color: #000;
  font-size: 15px;
  text-decoration: underline;
}

hr.grey {
  border: 1px solid #eaeaea;
}

/* -------------------------------------
    BUTTONS
------------------------------------- */
.btn {
  box-sizing: border-box;
  width: 100%;
  margin: 0px 0px;
}
.btn > tbody > tr > td {
}
.btn table {
  width: auto;
}
.btn table td {
  background-color: #ffffff;
  text-align: left;
}
.btn a {
  font-family: 'Poppins', sans-serif;
  background-color: #038ECF;
  border-radius: 5px;
  box-sizing: border-box;
  color: #fff !important;
  cursor: pointer;
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  margin-top: 20px;
  padding: 12px 24px;
  text-decoration: none;
}
.btn-primary table td {
  background-color: #000;
}
.btn-primary a {
  background-color: #000;
  border-color: #000;
  color: #ffffff !important;
}
/* -------------------------------------
    Table Styles
------------------------------------- */

.data-table {
  border: 1px solid #fff;
  margin: 0px 0px;
  font-family: 'Poppins';
  font-size:15px;
}

.data-table td,
.data-table th {
  border: 1px solid #fff;
  padding: 12px;
  font-family: 'Poppins';
  vertical-align: top;
}

.data-table th {
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: #d6d6d6;
  text-align: left;
}

.data-table td {
  padding: 15px 15px;
  background-color: #f2f2f2;
  text-align: left;
}

.data-table tr > td:first-child {
  font-weight: bold;
}

.itinerary-table{
    border:1px solid #EBEDF0;
    border-bottom: 0px;
}

.itinerary-table thead tr{
    background-color: #EBEDF0;
}

.itinerary-table tr th{
      text-align:left;
      padding: 10px 15px;
}

.itinerary-table tbody tr {
}
.itinerary-table tbody tr td{
    padding: 15px 15px;
    border-bottom: 1px solid #EBEDF0;
    vertical-align: middle;
}

.itinerary-table .pricing{
    min-width: 100px;
}

.itinerary-table .type-icon{
    min-width: 35px;
}

/* -------------------------------------
    Referral Table Styles
------------------------------------- */

.referral-table {
  border: 3px dashed black;
  margin: 0px 0px;
}

.referral-table td,
.referral-table th {
  border: 1px solid #fff;
  padding: 8px;
}

.referral-table th {
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #d6d6d6;
  text-align: left;
}

.referral-table td {
  padding: 15px 15px;
  background-color: #f2f2f2;
  text-align: left;
}

.referral-table tr > td:first-child {
  font-weight: bold;
}

/* -------------------------------------
    Content Table Styles
------------------------------------- */

.content-table{
    text-align: left;
}

.content-table td, .content-table th{
    padding-bottom: 7px;
    vertical-align: top;
}

.content-table th{
    width: 20%;
}

/* -------------------------------------
    OTHER STYLES THAT MIGHT BE USEFUL
------------------------------------- */
.password {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 25px;
  text-align: left;
  letter-spacing: 3px;
  display: block;
  margin-bottom: 20px;
  margin-top: 20px;
}

.last {
  margin-bottom: 0;
}
.first {
  margin-top: 0;
}
.align-center {
  text-align: center;
}
.align-right {
  text-align: right;
}
.align-left {
  text-align: left;
}
.clear {
  clear: both;
}
.mt0 {
  margin-top: 0;
}
.mb0 {
  margin-bottom: 0;
}
.preheader {
  color: transparent;
  display: none;
  height: 0;
  max-height: 0;
  max-width: 0;
  opacity: 0;
  overflow: hidden;
  mso-hide: all;
  visibility: hidden;
  width: 0;
}


.header-logo {
  height: 50px;
}

.body-img {
  border: none;
  margin: 20px 0px;
}

.app-icons {
  margin-top: 20px;
}

.no-dec {
  text-decoration: none;
}
.powered-by a {
  font-family: 'Poppins', sans-serif;
  text-decoration: none;
}
hr {
  border: 0;
  border-bottom: 1px solid #DCDEE0;
  margin: 20px 0px 20px 0px;
}
/* -------------------------------------
    RESPONSIVE AND MOBILE FRIENDLY STYLES
------------------------------------- */
@media only screen and (max-width: 620px) {

  .body h1 {
    font-size: 25px !important;
    line-height: 30px;
  }
  .body p,
  .body ul,
  .body ol,
  .body td,
  .body span,
  .body a {
    font-size: 16px !important;
    line-height: 25px;
  }  
  .body strong {
    font-size: 16px !important;
  }  
  .body table[class='data-table'] tr, 
  .body table[class='data-table'] td {
    font-size: 14px !important;   
    line-height: 20px;       
  }    
  .body {background-color: #fff;} .wrapper,
  .body .article {
    padding: 10px !important;
  }
  .body .content {
    padding: 0 !important;
  }
  .body .container {
    padding: 0 !important;
    width: 100% !important;
  }
  .body .main {
    border-left-width: 0 !important;
    border-radius: 0 !important;
    border-right-width: 0 !important;
  }
  .body .btn table {
    width: 100% !important;
  }
  .body .btn a {
    width: 100% !important;
  }
  .body .img-responsive {
    height: auto !important;
    max-width: 100% !important;
    width: auto !important;
  }
  .body .header-logo {
    margin-top: 20px;
  }
  .body .password {
    font-size: 22px !important;
  }
  .body .powered-by {
    font-size: 12px !important;
  }

  .body hr {
    margin: 30px 0px;
  }
  
  .warning {
      padding: 5px 10px;
      line-height: 18px;
  }
  
  .warning a{
      font-size: 13px !important;
  }

  table .data-table {
    font-size: 14px !important;  
  }

  .data-table {
    margin: 20px 0px;             
  }

  .data-table td,
  .data-table th {
    padding: 8px;
    line-height: 20px;
  }

  .data-table th {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .data-table td {
    padding: 10px 10px;
  }
}
/* -------------------------------------
    PRESERVE THESE STYLES IN THE HEAD
------------------------------------- */
@media all {
  .ExternalClass {
    width: 100%;
  }
  .ExternalClass,
  .ExternalClass p,
  .ExternalClass span,
  .ExternalClass font,
  .ExternalClass td,
  .ExternalClass div {
    line-height: 100%;
  }
  .apple-link a {
    color: inherit !important;
    font-family: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    text-decoration: none !important;
  }
  #MessageViewBody a {
    color: inherit;
    text-decoration: none;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
  .btn-primary table td:hover {
    background-color: #34495e !important;
  }
  .btn-primary a:hover {
    background-color: #34495e !important;
    border-color: #34495e !important;
  }
}
    </style>
  </head>
  <body id='body'>
    <span class="preheader"
      >{{snippet}}</span
    >
    <table
      role="presentation"
      border="0"
      cellpadding="0"
      cellspacing="0"
      class="body"
    >
      <tr>
        <td>&nbsp;</td>
        <td class="container">
          <div class="content">           
           <div class="warning">
          PLEASE DO NOT REPLY TO THIS EMAIL
      </div>
            <!-- START CENTERED WHITE CONTAINER -->
            <table role="presentation" class="main">
              <!-- START MAIN CONTENT AREA -->
              <tr>
                <td class="wrapper">
                  <table
                    role="presentation"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                  >
                    <tr>
                      <td align="left" style="padding-bottom:20px;">

                        <img
                          src="{{agent.logo}}"
                          alt="{{agent.name}}"
                          class="header-logo"
                          style="text-align:left;" 
                        />

                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{body_content}}
                        
                        <!-- START FOOTER -->
                        <hr style='padding: 10px; margin: 10px 0px 10px 0px; border-color: #ddd;'/>
                        
                        <div class="footer">
                          <table
                            role="presentation"
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                          >
                            <tr>
                              <td class="content-block powered-by">
                                © {{copyright_year}} Golfsavers. All Rights Reserved.
                              </td>
                            </tr>
                          </table>
                        </div>
                        <!-- END FOOTER -->
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <!-- END MAIN CONTENT AREA -->
            </table>

            <!-- END CENTERED WHITE CONTAINER -->
          </div>
        </td>
        <td>&nbsp;</td>
      </tr>
    </table>
  </body>
</html>

`;
exports.HOTEL_ORDER_LINE_STATE = {
    date_of_confirmation: null,
    where_when_who: {
        region_id: "",
        area_id: "",
        hotel_type: "",
        hotel: {
            id: null,
            name: null,
        },
        number_of_rooms: 0,
        number_of_guests: 0,
        pga_pros: {
            count: 0,
            room_allocation: [],
        },
        check_in_date: dayjs().format("YYYY-MM-DD"),
        number_of_nights: 1,
    },
    special_requests: "",
    checkinout: {
        check_in_time: "15:00",
        check_out_time: "12:00",
    },
    rooms: {
        rooms: [],
        rate_note: "",
        output_vat: 0,
        input_vat: 0,
        free_cancellation_days: 0,
        withholding_tax: 0,
        estimated: false,
        custom: false,
    },
    supplier: {
        id: null,
        name: "",
        currency: "",
    },
    adjustments: {
        margin_discount_percentage: 0,
    },
    supplier_deposit: {
        enabled: false,
        amount: 0,
        type: "PERCENTAGE",
        days_before: 0,
    },
    voucher_notes: "",
    workflow_settings: {
        mode: "AUTO",
    },
};
exports.EXCURSTION_LINE_INITIAL_STATE = {
    date_of_confirmation: null,
    workflow_settings: {
        mode: "AUTO",
    },
    where_when_who: {
        region_id: "",
        date: dayjs().format("YYYY-MM-DD"),
        number_of_people: 1,
    },
    product: {
        custom: false,
        rate: undefined,
        historic_rate: null,
    },
    transfers: {
        pickup_area_id: "",
        pickup_time: "",
        pickup_name: "",
    },
    supplier: {
        id: "",
        name: "",
        currency: "",
    },
    voucher_notes: "",
    adjustments: {
        margin_discount_percentage: 0,
    },
    supplier_deposit: {
        enabled: false,
        amount: 0,
        type: "PERCENTAGE",
        days_before: 0,
    },
};
exports.GOLF_LINE_INITIAL_STATE = {
    date_of_confirmation: null,
    workflow_settings: {
        mode: "AUTO",
    },
    where_when_who: {
        region_id: undefined,
        hole_option: "ANY",
        date: dayjs().add(1, "day").format("YYYY-MM-DD"),
        number_of_golfers: 2,
    },
    course: {
        id: undefined,
        name: undefined,
        policies: undefined,
        closures: [],
        warnings: [],
        public_holidays: [],
        hole_options: [],
    },
    hole_options: {
        hole_options: [],
        selected_option: "",
    },
    supplier: {
        id: "",
        name: "",
        currency: "",
    },
    product: {
        id: null,
        name: null,
        type: "",
        config: null,
        custom: false,
    },
    green_fee: {
        output_vat: 0,
        input_vat: 0,
        multiples: 0,
        historic_rate: null,
        estimated: false,
        rate_note: "",
        withholding_tax: 0,
        rate_id: "",
        caddie_price: 0,
        single_cart_enabled: false,
        single_cart_price: 0,
        shared_cart_enabled: false,
        shared_cart_price: 0,
        odd_number_surcharge: 0,
        max_pax: 0,
        margin: 0,
        cost: 0,
        price: 0,
        caddie_policy: "",
        cart_policy: "",
        surcharge: 0,
        availability_days: null,
        earliest_time: "",
        latest_time: "",
        start_date: "",
        end_date: "",
        booking_window_start_date: "",
        booking_window_end_date: "",
    },
    tee_time: {
        note: "",
        custom: false,
        start_time: "",
        end_time: "",
        groups: [],
    },
    caddies: {
        enabled: false,
        output_vat: 0,
        input_vat: 0,
        withholding_tax: 0,
        type: "",
        cost_per_caddie: 0,
        quantity: 0,
        total: 0,
        payment_option: null,
    },
    carts: {
        enabled: false,
        output_vat: 0,
        input_vat: 0,
        withholding_tax: 0,
        types: null,
        payment_option: null,
    },
    golfer_info: {
        enabled: false,
        players: [],
    },
    voucher_notes: "",
    adjustments: {
        margin_discount_percentage: 0,
    },
    supplier_deposit: {
        enabled: false,
        amount: 0,
        type: "PERCENTAGE",
        days_before: 0,
    },
};
exports.TRANSFER_LINE_INITIAL_STATE = {
    date_of_confirmation: null,
    workflow_settings: {
        mode: "AUTO",
    },
    where_when_who: {
        region_id: undefined,
        number_of_passengers: 0,
        type: "RETURN",
        date: undefined,
        pickup_name: undefined,
    },
    supplier: {
        id: "",
        name: "",
        currency: "",
        notes: "",
    },
    driver: {
        pickup_time: "",
        name: "",
        phone: "",
        updated_at: null,
        updated_by: "",
    },
    transfer_legs: {
        outbound: {
            from_area: "",
            from_name: "",
            from_type: "",
            from_details: null,
            to_area: "",
            to_name: "",
            to_type: "",
            to_details: null,
        },
        inbound: {
            from_area: "",
            from_name: "",
            from_type: "",
            from_details: null,
            to_area: "",
            to_name: "",
            to_type: "",
            to_details: null,
        },
    },
    vehicle: {
        custom: false,
        historic_rate: null,
        vehicle: null,
        rate: {
            inbound: "",
            outbound: "",
            type: "",
            estimated: false,
        },
        max_pax: 0,
        inbound_cost: 0,
        inbound_margin: 0,
        inbound_price: 0,
        inbound_total: 0,
        outbound_cost: 0,
        outbound_margin: 0,
        outbound_price: 0,
        outbound_total: 0,
        cost: 0,
        margin: 0,
        price: 0,
        quantity: 0,
        total: 0,
        output_vat: 0,
        input_vat: 0,
        withholding_tax: 0,
    },
    voucher_notes: "",
    adjustments: {
        margin_discount_percentage: 0,
    },
    supplier_deposit: {
        enabled: false,
        amount: 0,
        type: "PERCENTAGE",
        days_before: 0,
    },
};
exports.CUSTOM_LINE_INITIAL_STATE = {
    date_of_confirmation: null,
    where_when_who: {
        date: dayjs().format("YYYY-MM-DD"),
        duration: 1,
        pax: 1,
        product_description: [],
        title: "",
        product_type: null,
        type: "EXTRA_ITEM",
        region_id: "",
        country_id: "",
    },
    pricing: {
        cost: 0,
        price: 0,
        margin: 0,
        output_vat: 0,
        input_vat: 0,
        withholding_tax: 0,
        quantity: 1,
        estimated: false,
        total: 0,
    },
    supplier: {
        currency: "",
        id: "",
        name: "",
    },
    supplier_deposit: {
        amount: 0,
        days_before: 0,
        enabled: false,
        type: "PERCENTAGE",
    },
    voucher_notes: "",
    adjustments: {
        margin_discount_percentage: 0,
    },
    workflow_settings: {
        mode: "AUTO",
    },
};
exports.NEW_ORDER_LEG = {
    where_when_who: {
        region_id: "",
        start_date: "",
        duration_days: 1,
        number_of_golfers: 2,
        number_of_non_golfers: 0,
    },
    hotel: {
        ...exports.HOTEL_ORDER_LINE_STATE,
        where_when_who: {
            ...exports.HOTEL_ORDER_LINE_STATE.where_when_who,
            number_of_nights: 1,
            number_of_guests: 2,
            pga_pros: {
                count: 0,
                room_allocation: [],
            },
        },
    },
    courses: [],
    transfers: {
        type: "golf",
        arrival_airport: "",
        departure_airport: "",
        return_to_origin_airport: true,
        primary_pickup_area: null,
        arrival_airport_enabled: false,
        departure_airport_enabled: false,
        address: "",
    },
    tee_time: "cheapest",
    course_combo_id: "",
};
exports.NEW_BUILD_ITINERARY = {
    trip: {
        type: "GOLF_HOTEL",
        region_id: null,
        country_id: null,
        start_date: null,
        end_date: null,
        duration_days_nights: null,
        number_of_golfers: null,
        number_of_non_golfers: 0,
        pga_pros: {
            count: 0,
            room_allocation: [],
        },
    },
    discounts: {
        historic_pricing_adjustment: {
            golf: 5,
            hotels: 5,
            transfers: 5,
            excursions: 5,
            custom: 5,
            other: 5,
        },
        margin_discount_percentages: {
            excursions: 0,
            golf: 0,
            hotels: 0,
            transfers: 0,
        },
    },
    course_lists: {
        custom: [],
        top_rated: [],
        best_sellers: [],
        best_value: [],
    },
    hotel: {
        ...exports.HOTEL_ORDER_LINE_STATE,
        where_when_who: {
            ...exports.HOTEL_ORDER_LINE_STATE.where_when_who,
            number_of_nights: 1,
            number_of_guests: 2,
            number_of_pga_pros: 0,
        },
    },
    golf: {
        number_of_rounds: null,
        preferred_course_type: "TOP_RATED",
        golf_extras: "ALL",
        tee_time_preference: {
            start_time: "06:00",
            end_time: "13:30",
            custom: false,
        },
        courses: [],
    },
    transfers: {
        type: models_1.TransferType.GOLF_AIRPORT,
        time_of_arrival: 30,
        arrival_airport: null,
        arrival_airport_enabled: true,
        arrival_transfer_type: "CUSTOM",
        departure_airport: null,
        departure_airport_enabled: true,
        departure_transfer_type: "CUSTOM",
        return_to_origin_airport: true,
        primary_pickup_area: null,
        inter_region_transfer_type: null,
        leg_adjustments: null,
    },
    courses: {
        itinerary: [],
        rate_matrix: [],
        rates: [],
    },
};
